











import { Vue, Component, Prop } from 'vue-property-decorator'
import 'reflect-metadata'

@Component({
    components: {},
    filters: {},
})
export default class EVMExecutionTrace extends Vue {
    @Prop() traces!: any[]

    items: any[] = []

    created() {
        this.items = this.traces
    }
}
